var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyDetailWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52248 9.05401H3.6199C3.05935 9.05401 2.77907 9.05401 2.56497 9.1631C2.37664 9.25906 2.22352 9.41218 2.12756 9.60051C2.01847 9.81461 2.01847 10.0949 2.01847 10.6554V19.0629M15.5305 9.05401H18.4331C18.9937 9.05401 19.2739 9.05401 19.488 9.1631C19.6764 9.25906 19.8295 9.41218 19.9254 9.60051C20.0345 9.81461 20.0345 10.0949 20.0345 10.6554V19.0629M15.5305 19.0629V4.24973C15.5305 3.12863 15.5305 2.56807 15.3123 2.13987C15.1204 1.76321 14.8142 1.45697 14.4375 1.26506C14.0093 1.04688 13.4488 1.04688 12.3277 1.04688H9.72534C8.60423 1.04688 8.04368 1.04688 7.61548 1.26506C7.23882 1.45697 6.93258 1.76321 6.74067 2.13987C6.52248 2.56807 6.52248 3.12863 6.52248 4.24973V19.0629M21.0354 19.0629H1.01758M10.0256 5.05044H12.0274M10.0256 9.05401H12.0274M10.0256 13.0576H12.0274",
    stroke: "white",
    strokeWidth: 2.00178,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyDetailWhite);
export default __webpack_public_path__ + "static/media/company-detail-white.305b418504915facb84b4c4354940685.svg";
export { ForwardRef as ReactComponent };